import React from "react";
import TurnrInput from "~/components/input/TurnrInput.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";

export default function LogoSettings(props) {
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="The brand is used on the app but may also be used when sending automatic emails"
                    label="Shop logo url"
                    fullWidth={true}
                    {...props.logoSrc}
                    onChange={props.setLogoSrc}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="It's hard for us to know what size bests suits your logo. Play around a little"
                    type="number"
                    label="Shop logo height"
                    min={0}
                    fullWidth={true}
                    {...props.logoHeight}
                    onChange={props.setLogoHeight}
                    required
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="Optional. You might find that a different size of your logo looks better in mobile view"
                    type="number"
                    label="Shop logo height mobile"
                    min={0}
                    fullWidth={true}
                    {...props.logoHeightMobile}
                    onChange={props.setLogoHeightMobile}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="Optional. This is the logo in login mobile view where the logo is directly against the background image. "
                    label="Mobile login logo url"
                    fullWidth={true}
                    {...props.alternativeLogoSrc}
                    onChange={props.setAlternativeLogoSrc}
                />
            </InputGridWrapper>
            {props.alternativeLogoSrc.value && (
                <InputGridWrapper>
                    <TurnrInput
                        size={"small"}
                        tooltip="Required if you have set the Mobile logo url"
                        type="number"
                        label="Mobile login logo height"
                        required
                        min={0}
                        fullWidth={true}
                        {...props.alternativeLogoHeight}
                        onChange={props.setAlternativeLogoHeight}
                    />
                </InputGridWrapper>
            )}
        </SettingsContainerWrapper>
    );
}
